'use client';

import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/utils/ui-utils';

const notificationVariants = cva('relative h-5 w-5 rounded-full text-xs font-bold', {
  variants: {
    variant: {
      default: 'bg-bui-color-orange text-white',
      inactive: 'bg-muted text-foreground',
    },
  },
  defaultVariants: { variant: 'default' },
});

interface NotificationProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof notificationVariants> {
  value: string | number;
}

export function Notification({ value, variant, className, ...props }: NotificationProps) {
  return (
    <div
      className={cn(notificationVariants({ variant, className }))}
      {...props}
    >
      <span className='text-xxs absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2'>{value}</span>
    </div>
  );
}
